import { Dispatch, SetStateAction } from "react";
import styles from "./styles.module.scss";
import { TypesMarks, typesMarksMap } from "./mock";

export const handleInputChange =
  (setter: Dispatch<SetStateAction<number>>) =>
  (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value) || 0;
    setter(value);
  };

export const renderDropdown = (
  label: string,
  value: string,
  dropdown: string,
  options: string[],
  dropdownOpen: string | null,
  setDropdownOpen: Dispatch<SetStateAction<string | null>>,
  setValue: Dispatch<SetStateAction<string>>,
) => (
  <div className={styles.inptWrapper}>
    <label>{label}</label>
    <div
      className={styles.dropdown}
      onClick={() =>
        setDropdownOpen(dropdownOpen === dropdown ? null : dropdown)
      }
    >
      <span>{value}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        className={styles.dropdownOpen === dropdown ? "iconOpen" : ""}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.814779 2.44434C0.364789 1.99435 0.364789 1.26477 0.814779 0.814779C1.26477 0.364789 1.99435 0.364789 2.44434 0.814779L5.17778 3.54823C5.63188 4.00232 6.36812 4.00232 6.82222 3.54823L9.55566 0.814779C10.0057 0.364789 10.7352 0.364789 11.1852 0.814779C11.6352 1.26477 11.6352 1.99435 11.1852 2.44434L6.82222 6.80734C6.36812 7.26144 5.63188 7.26144 5.17778 6.80734L0.814779 2.44434Z"
          fill="white"
        />
      </svg>
    </div>
    {dropdownOpen === dropdown && (
      <div className={styles.dropdownMenu}>
        {options.map((option) => (
          <div
            key={option}
            className={styles.dropdownItem}
            onClick={() => {
              setValue(option);
              setDropdownOpen(null);
            }}
          >
            {option}
          </div>
        ))}
      </div>
    )}
  </div>
);

// Gantt Chart
// render lines coordinates
export const generateLinksFromDeliveryData = (deliveryData) => {
  const links = [];

  deliveryData.forEach((item) => {
    const keys = item.keys;

    for (let i = 0; i < keys.length - 1; i++) {
      const currentKey = keys[i];
      const nextKey = keys[i + 1];

      const currentPeriods = [
        ...(currentKey.periods?.pasted || []),
        ...(currentKey.periods?.predict || []),
      ];
      const nextPeriods = [
        ...(nextKey.periods?.pasted || []),
        ...(nextKey.periods?.predict || []),
      ];

      currentPeriods.forEach((currentPeriod, index) => {
        if (nextPeriods[index]) {
          links.push({
            from: new Date(currentPeriod.end).getTime(),
            to: new Date(nextPeriods[index].start).getTime(),
            fromIdx: i,
            toIdx: i + 1,
          });
        }
      });
    }
  });

  return links;
};
